import { render, staticRenderFns } from "./stock-sale.vue?vue&type=template&id=2156a6e4&"
import script from "./stock-sale.vue?vue&type=script&lang=js&"
export * from "./stock-sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports